const actions = {
  FETCH_AUDIT_LOGS: 'FETCH_AUDIT_LOGS',
  FETCHING_AUDIT_LOGS: 'FETCHING_AUDIT_LOGS',
  FETCH_AUDIT_LOGS_SUCCESS: 'FETCH_AUDIT_LOGS_SUCCESS',
  FETCH_AUDIT_LOGS_FAILED: 'FETCH_AUDIT_LOGS_FAILED',

  fetchAuditLogs: payload => ({
    type: actions.FETCH_AUDIT_LOGS,
    payload
  })
};
export default actions;
